import { defineStore } from "pinia";
import { login, Logout } from "@/api/obj.api";
import { useAdditionalAttrStore } from "./AdditionalAttrStore";

const user = { SessionId: "", Tenant: "" };

export const useLoginStore = defineStore("loginSession", {
  state: () => ({
    isLoggedIn: false,
    user: user,
  }),
  getters: {
    getwebsession(state) {
      if (state.user) {
        return state.user.SessionId;
      }
    },
    getLoginStatus(state) {
      if (state.isLoggedIn && state.user && state.user.SessionId) {
        return state.isLoggedIn;
      } else {
        return false;
      }
    },
    generateShortUUID() {
      const attribute = useAdditionalAttrStore();
      if (attribute.dataConfig.websessionId !== "") {
        return attribute.dataConfig.websessionId;
      }
      const timestamp = Date.now().toString(36);
      const randomChars = Math.random().toString(36).substring(2, 5); // Using 5 characters for randomness
      return `${timestamp}${randomChars}`.toUpperCase().slice(0, 9);
    },
    getTenant(state) {
      if (state.user && state.user.Tenant) {
        return state.user.Tenant;
      }
    },
  },
  actions: {
    async LoginToStore() {
      const loginInfo = await login();
      this.isLoggedIn = true;
      this.user = await loginInfo;
      return true;
    },
    async logout() {
      await Logout();
      this.isLoggedIn = false;
      this.user = { SessionId: "", Tenant: "" };
    },
  },
});
